"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _Typography = require("../Typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Section = function Section(_ref) {
  var children = _ref.children,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/_react.default.createElement(StyledSection, _extends({}, otherProps, {
    className: className
  }), children);
};

var StyledSection = _styledComponents.default.section.withConfig({
  displayName: "StyledSection"
})(["font-family:", ";width:100%;max-width:100rem;margin-bottom:4.5rem;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
});

var Subtitle = _styledComponents.default.h2.withConfig({
  displayName: "Subtitle"
})(["font-size:1.6rem;"]);

var Content = _styledComponents.default.div.withConfig({
  displayName: "Content"
})(["background-color:", ";position:relative;font-size:1.6rem;padding:", ";border:", ";box-shadow:", ";border-radius:0.5rem;margin-top:2rem;"], function (props) {
  return props.background ? 'white' : 'none';
}, function (props) {
  return props.background ? '3.2rem' : 'none';
}, function (_ref3) {
  var theme = _ref3.theme,
      background = _ref3.background;
  return background ? "0.1rem solid ".concat(theme.ui.outline) : 'none';
}, function (props) {
  return props.background ? '0 0.2rem 0.5rem rgba(0, 0, 0, 0.05)' : 'none';
});

Section.defaultProps = {
  otherProps: {}
};
Section.propTypes = {
  children: _propTypes.node,
  className: _propTypes.string,
  otherProps: _propTypes.object
};
Section.Title = _Typography.SubTitle;
Section.Title.displayName = 'Section.Title';
Section.Subtitle = Subtitle;
Section.Subtitle.displayName = 'Section.Subtitle';
Section.Content = Content;
Section.Content.displayName = 'Section.Content';
var _default = Section;
exports.default = _default;